import { render } from "./RestorePassword.vue?vue&type=template&id=30603540&scoped=true"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=30603540&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30603540"]])

export default __exports__